"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _resistOfGoblins = require("../../../../services/resistOfGoblins");
var _useHover = require("../../../../services/useHover");
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Item = function Item(_ref) {
  var className = _ref.className,
    children = _ref.children,
    compact = _ref.compact,
    deleteButton = _ref.deleteButton,
    price = _ref.price,
    onIntersection = _ref.onIntersection,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave;
  var cachedPrice = (0, _react.useRef)(price);
  var itemRef = (0, _react.useRef)(null);
  var _useResistOfInjection = (0, _resistOfGoblins.useResistOfInjection)(),
    getRefPromise = _useResistOfInjection.getRefPromise,
    setRef = _useResistOfInjection.setRef;
  var itemHoverAPI = (0, _useHover.useHover)({
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  });
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    priceUpdated = _useState2[0],
    setUpdated = _useState2[1];
  var combinedRef = function combinedRef(node) {
    setRef(node);
    itemRef.current = node;
    itemHoverAPI.setRef(node);
  };
  (0, _react.useEffect)(function () {
    var prevPrice = cachedPrice.current;
    if (price !== prevPrice) {
      var itemNode = itemRef.current;
      var handleEndAnimation = function handleEndAnimation() {
        return setUpdated(false);
      };
      itemNode.addEventListener('transitionend', handleEndAnimation);
      setUpdated(true);
      return function () {
        itemNode.removeEventListener('transitionend', handleEndAnimation);
      };
    }
  }, [price]);
  (0, _react.useEffect)(function () {
    if (onIntersection) {
      var intersectionObserver = new IntersectionObserver(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 1),
          isIntersecting = _ref3[0].isIntersecting;
        if (isIntersecting) {
          onIntersection();
          intersectionObserver.disconnect();
        }
      }, {
        threshold: 0.25
      });
      getRefPromise().then(function (nodeDOM) {
        intersectionObserver.observe(nodeDOM);
      });
      return function () {
        intersectionObserver.disconnect();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onIntersection]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)(_styles.default.resultItem, className, _defineProperty(_defineProperty({}, _styles.default.priceUpdated, priceUpdated), _styles.default.compact, compact)),
    ref: combinedRef
  }, deleteButton, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.resultBody
  }, children));
};
Item.propTypes = {
  price: _propTypes.default.number.isRequired,
  children: _propTypes.default.any,
  className: _propTypes.default.string,
  compact: _propTypes.default.bool,
  deleteButton: _propTypes.default.node,
  onIntersection: _propTypes.default.func,
  onMouseEnter: _propTypes.default.func,
  onMouseLeave: _propTypes.default.func
};
var _default = exports.default = (0, _react.memo)(Item);